import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/X";
import { Link as RouterLink } from "react-router-dom";
import { brandGradient } from "../shared-theme/themePrimitives";

function Copyright() {
  return (
    <>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mt: 1,
          width: "100%",
          textAlign: "center",
        }}
      >
        {"Copyright © TheCreatorMatch "}
        {new Date().getFullYear()}
        <br />
        <br />
        {"Powered by VibrantLogics"}
      </Typography>
    </>
  );
}

export default function Footer() {
  return (
    <React.Fragment>
      <Divider />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          textAlign: { sm: "center", md: "left" },
          pt: 2,
          pb: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pt: { xs: 4, sm: 4 },
            width: "100%",
            borderColor: "divider",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div
              style={{
                width: "25%",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Link
                component={RouterLink}
                color="text.secondary"
                variant="body2"
                to="/privacy"
              >
                Privacy Policy
              </Link>

              <Link
                component={RouterLink}
                color="text.secondary"
                variant="body2"
                to="/terms"
              >
                Terms of Service
              </Link>

              <Link
                component={RouterLink}
                color="text.secondary"
                variant="body2"
                to="/contact"
              >
                Contact
              </Link>
            </div>

            <Copyright />
            <div style={{ width: "25%", display: "flex", gap: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Link
                  component={RouterLink}
                  color="text.secondary"
                  variant="body2"
                  to="/features"
                >
                  Features
                </Link>

                <Link
                  component={RouterLink}
                  color="text.secondary"
                  variant="body2"
                  to="/highlights"
                >
                  Highlights
                </Link>

                <Link
                  component={RouterLink}
                  color="text.secondary"
                  variant="body2"
                  to="/faq"
                >
                  FAQs
                </Link>
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Link
                  component={RouterLink}
                  color="text.secondary"
                  variant="body2"
                  to="/about"
                >
                  About Us
                </Link>

                <Link
                  component={RouterLink}
                  color="text.secondary"
                  variant="body2"
                  to="/press"
                >
                  Press
                </Link>
              </div>
            </div>
          </div>
        </Box>
      </Container>
    </React.Fragment>
  );
}
